/**
 * CookiePref.js — Cookie / privacy preference modal.
 *
 * Shown automatically on the user's first visit (until they accept).
 * Explains the site's cookie usage and provides an Accept button.
 * On accept, HideCookiePrefPopup persists the choice to localStorage.
 *
 * Props:
 *  - CookiePrefPopup {boolean}        Whether the modal is visible.
 *  - HideCookiePrefPopup {Function}   Closes modal and persists acceptance.
 *  - ShowCookiePrefPopup {Function}   Reopens the modal.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React from 'react';
import {
    Modal,
    Button
} from 'react-bootstrap';
export const CookiePref = (props) => {
    return (
        <>
            <Modal className="cookie_pref_modal" size="lg" show={props.CookiePrefPopup} onHide={props.HideCookiePrefPopup} scrollable>
                <Modal.Header closeButton className="border-0 pb-0">
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <Modal.Title as="h4" className="mb-4">Privacy Preferences</Modal.Title>
                    <div className="about_page_wrapper">
                        <p>Our website uses cookies and similar technology to monitor a user’s use and navigation around our website. We may use that information to market more effectively to users and improve our services including our website.</p>
                        <p>We may engage third parties to use the information provided by cookies and similar technology, in order to direct advertising to our website users. Those third parties may have privacy policies which we do not control.</p>
                        <p>You may set your browser to block or manage cookies, however that may result in reduced effectiveness or experience of our website.</p>
                    </div>
                    <div className="form-group text-center">
                        <Button variant="primary" type="button" onClick={props.HideCookiePrefPopup} className="btn-lg border-2 rounded-2">Accept!</Button>
                    </div>
                </Modal.Body>
            </Modal>    </>
    )
}